export default {
  "save-success": {
    EN: "Your sending domain was saved. Add the DNS records below to finish verification.",
  },
  "save-failure": {
    EN: "Failed to save email identity.",
  },
  "delete-success": {
    EN: "Custom sending domain removed.",
  },
  "delete-failure": {
    EN: "Failed to remove domain.",
  },
  "refresh-verified": {
    EN: "Your domain is verified!",
  },
  "refresh-pending": {
    EN: "Your domain is still pending verification. If you recently updated DNS, please try again in a few minutes.",
  },
  "refresh-failure": {
    EN: "Failed to refresh status.",
  },
  "toggle-failure": {
    EN: "Failed to update toggle.",
  },
  "send-test-email-success": {
    EN: "Test email sent to your inbox.",
  },
  "send-test-email-failure": {
    EN: "Failed to send test email.",
  },
};
